import type { Token } from '../api-types';
import type { Token as TokenType } from '../types/tokens';

export function transformToken(res: Token): TokenType {
  return {
    claimedBy: res.claimed_by,
    claimedTime: res.claimed_time,
    createdBy: res.created_by,
    creationTime: res.creation_time,
    releasedBy: res.released_by,
    releaseTime: res.release_time,
    expiryTime: res.expiry_time,
    id: res.id,
    autoRotated: res.auto_rotated,
  };
}
